var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      attrs: {
        "grid-list-md": "",
        fluid: "",
        "px-0": "",
        "py-0": "",
        id: "search-container",
      },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", "pa-0": "" } },
            [
              _c(
                "v-parallax",
                {
                  attrs: {
                    height: _vm.windowHeight,
                    src: require("./assets/bg-tmp3.png"),
                  },
                },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "marv-bg-fg",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "12" } },
                        [
                          _c(
                            "h1",
                            { staticClass: "text-h3 font-weight-light mb-4" },
                            [
                              _vm._v(
                                "\n                            Protein Interface Clusters\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h4",
                            { staticClass: "text-h6 font-weight-light mb-4" },
                            [
                              _vm._v(
                                "\n                            Explore clusters of protein interfaces from the "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.rcsb.org",
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [_vm._v("Protein Data Bank")]
                              ),
                              _vm._v(" using "),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://foldseek.com",
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [_vm._v("Foldseek-Interface")]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "v-tabs",
                            {
                              staticClass: "search-select",
                              attrs: {
                                "slider-size": "1",
                                centered: "",
                                "background-color": "transparent",
                                dark: "",
                              },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _c("v-tab", [_vm._v("Accession")]),
                              _vm._v(" "),
                              _c("v-tab", [_vm._v("Taxonomy")]),
                              _vm._v(" "),
                              _c("v-tab", [_vm._v("Structure")]),
                              _vm._v(" "),
                              _c("v-tab", [_vm._v("Cluster ID")]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tabs-items",
                            {
                              staticStyle: { padding: "1em" },
                              model: {
                                value: _vm.tab,
                                callback: function ($$v) {
                                  _vm.tab = $$v
                                },
                                expression: "tab",
                              },
                            },
                            [
                              _c(
                                "v-tab-item",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "max-width": "400px",
                                        margin: "0 auto",
                                      },
                                    },
                                    [
                                      _vm._l(
                                        _vm.queryAccessions,
                                        function (accession, index) {
                                          return _c(
                                            "div",
                                            {
                                              key: index,
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                "margin-bottom": "8px",
                                              },
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticStyle: { flex: "1" },
                                                attrs: {
                                                  outlined: "",
                                                  "hide-details":
                                                    index === 0
                                                      ? _vm.error == null
                                                      : true,
                                                  label:
                                                    index === 0
                                                      ? "PDB/UniProt Accession"
                                                      : "UniProt Accession",
                                                  "append-icon":
                                                    index === 0 && _vm.inSearch
                                                      ? _vm.$MDI.ProgressWrench
                                                      : index === 0
                                                      ? _vm.$MDI.Magnify
                                                      : "",
                                                  disabled: _vm.inSearch,
                                                  error:
                                                    _vm.error != null &&
                                                    index === 0,
                                                  "error-messages":
                                                    _vm.error && index === 0
                                                      ? _vm.error
                                                      : [],
                                                  dark: "",
                                                },
                                                on: {
                                                  "click:append": function (
                                                    $event
                                                  ) {
                                                    index === 0
                                                      ? _vm.search()
                                                      : null
                                                  },
                                                  keyup: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    return _vm.search.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    _vm.selectedExample = null
                                                  },
                                                  keydown: function ($event) {
                                                    _vm.error = null
                                                  },
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryAccessions[index],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryAccessions,
                                                      index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryAccessions[index]",
                                                },
                                              }),
                                              _vm._v(" "),
                                              index > 0
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "4px",
                                                      },
                                                      attrs: {
                                                        icon: "",
                                                        dark: "",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.queryAccessions.splice(
                                                            index,
                                                            1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$MDI.MinusBox
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _vm.queryAccessions.length < 2 &&
                                      _vm.queryAccessions[0]
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-bottom": "16px",
                                                "margin-top": "0px",
                                              },
                                            },
                                            [
                                              _c("v-text-field", {
                                                staticStyle: { flex: "1" },
                                                attrs: {
                                                  outlined: "",
                                                  "hide-details": "",
                                                  label:
                                                    "(Optional) UniProt Accession",
                                                  disabled: _vm.inSearch,
                                                  error: _vm.error != null,
                                                  "error-messages": _vm.error
                                                    ? _vm.error
                                                    : [],
                                                  dark: "",
                                                },
                                                on: {
                                                  keyup: function ($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    )
                                                      return null
                                                    return _vm.search.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                  change: function ($event) {
                                                    _vm.selectedExample = null
                                                  },
                                                  keydown: function ($event) {
                                                    _vm.error = null
                                                  },
                                                },
                                                model: {
                                                  value: _vm.queryAccessions[1],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryAccessions,
                                                      1,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryAccessions[1]",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  [
                                    _c("h2", { staticClass: "text-h6 mb-2" }, [
                                      _vm._v("Examples"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-chip-group",
                                      {
                                        staticStyle: {
                                          "max-width": "600px",
                                          margin: "0 auto",
                                        },
                                        attrs: { column: "", dark: "" },
                                        model: {
                                          value: _vm.selectedExample,
                                          callback: function ($$v) {
                                            _vm.selectedExample = $$v
                                          },
                                          expression: "selectedExample",
                                        },
                                      },
                                      _vm._l(
                                        _vm.accessionexamples,
                                        function (item) {
                                          return _c(
                                            "v-chip",
                                            {
                                              key: item.id,
                                              attrs: { outlined: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.queryAccessions = item.id2
                                                    ? [item.id, item.id2]
                                                    : [item.id]
                                                },
                                              },
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(_vm._s(item.id)),
                                              ]),
                                              item.id2
                                                ? _c("span", [
                                                    _vm._v(" - "),
                                                    _c("b", [
                                                      _vm._v(_vm._s(item.id2)),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(
                                                "   " +
                                                  _vm._s(item.desc) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                [
                                  _c("TaxonomyNcbiSearch", {
                                    attrs: {
                                      "append-icon": _vm.inSearch
                                        ? _vm.$MDI.ProgressWrench
                                        : _vm.$MDI.Magnify,
                                      value: _vm.queryLCA
                                        ? _vm.queryLCA.text
                                        : "",
                                    },
                                    on: {
                                      "click:append": _vm.searchLCA,
                                      input: _vm.searchLCA,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.searchLCA.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.queryLCA,
                                      callback: function ($$v) {
                                        _vm.queryLCA = $$v
                                      },
                                      expression: "queryLCA",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      staticStyle: {
                                        "max-width": "400px",
                                        margin: "0 auto",
                                      },
                                      attrs: { inline: "" },
                                      model: {
                                        value: _vm.lcaSearchType,
                                        callback: function ($$v) {
                                          _vm.lcaSearchType = $$v
                                        },
                                        expression: "lcaSearchType",
                                      },
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          name: "lcaSearchType",
                                          label: "Include lower LCA lineage",
                                          value: "lower",
                                          dark: "",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          name: "lcaSearchType",
                                          label: "Exact LCA identifier",
                                          value: "exact",
                                          dark: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                [
                                  _c("FoldseekSearchButton", {
                                    attrs: { dark: "" },
                                    on: {
                                      response: function ($event) {
                                        return _vm.searchFoldseek($event)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-tab-item",
                                [
                                  _c("v-text-field", {
                                    staticStyle: {
                                      "max-width": "400px",
                                      margin: "0 auto",
                                    },
                                    attrs: {
                                      outlined: "",
                                      label: "Cluster ID",
                                      "append-icon": _vm.inSearch
                                        ? _vm.$MDI.ProgressWrench
                                        : _vm.$MDI.Magnify,
                                      disabled: _vm.inSearch,
                                      error: _vm.error != null,
                                      "error-messages": _vm.error
                                        ? _vm.error
                                        : [],
                                      dark: "",
                                    },
                                    on: {
                                      "click:append": _vm.searchCluster,
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        )
                                          return null
                                        return _vm.searchCluster.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                      change: function ($event) {
                                        _vm.selectedExample = null
                                      },
                                      keydown: function ($event) {
                                        _vm.error = null
                                      },
                                    },
                                    model: {
                                      value: _vm.query,
                                      callback: function ($$v) {
                                        _vm.query = $$v
                                      },
                                      expression: "query",
                                    },
                                  }),
                                  _vm._v(" "),
                                  [
                                    _c("h2", { staticClass: "text-h6 mb-2" }, [
                                      _vm._v(
                                        "\n                                        Examples\n                                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-chip-group",
                                      {
                                        staticStyle: {
                                          "max-width": "400px",
                                          margin: "0 auto",
                                        },
                                        attrs: { column: "", dark: "" },
                                        model: {
                                          value: _vm.selectedExample,
                                          callback: function ($$v) {
                                            _vm.selectedExample = $$v
                                          },
                                          expression: "selectedExample",
                                        },
                                      },
                                      _vm._l(
                                        _vm.intcluexamples,
                                        function (item) {
                                          return _c(
                                            "v-chip",
                                            {
                                              key: item.id,
                                              attrs: { outlined: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.query = item.id
                                                },
                                              },
                                            },
                                            [
                                              _c("b", [
                                                _vm._v(_vm._s(item.id)),
                                              ]),
                                              _vm._v(
                                                "   " +
                                                  _vm._s(item.desc) +
                                                  "\n                                        "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tab == 0
            ? _c("SearchResult", {
                on: {
                  total: function ($event) {
                    _vm.small = $event > 0
                    _vm.inSearch = false
                  },
                },
              })
            : _vm.tab == 1
            ? _c("LCASearchResult", {
                on: {
                  total: function ($event) {
                    _vm.small = $event > 0
                    _vm.inSearch = false
                  },
                },
              })
            : _vm.tab == 2
            ? _c("FoldseekSearchResult", {
                on: {
                  total: function ($event) {
                    _vm.small = $event > 0
                    _vm.inSearch = false
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "v-card",
                { attrs: { flat: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pb-0 mb-0",
                          attrs: { "primary-title": "" },
                        },
                        [
                          _c("div", { staticClass: "text-h5 mb-0" }, [
                            _vm._v("Reference"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-title",
                        {
                          staticClass: "pt-0 mt-0",
                          attrs: { "primary-title": "" },
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "text-subtitle-1 mb-0",
                              staticStyle: { "word-break": "break-word" },
                            },
                            [
                              _vm._v(
                                "\n                            Strom J.M, Cha S, Kim R.S, Sajal H, Gilchrist CLM, Steinegger M, Luck K. \n                            "
                              ),
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: "https://www.biorxiv.org/content/10.64898/2026.08.24.746585v2\\",
                                    target: "_blank",
                                    rel: "noopener",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Foldseek-Interface reveals a protein interface universe far from complete\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                        , bioRxiv, 2026.\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "text-subtitle-1 mb-0 collab" }, [
                _vm._v(
                  "\n                Protein Interface Clusters is a collaboration between\n                "
                ),
                _c("a", { attrs: { href: "https://en.snu.ac.kr/" } }, [
                  _vm._v("Seoul National University"),
                ]),
                _vm._v(" and the\n                "),
                _c("a", { attrs: { href: "https://www.imb.de/" } }, [
                  _vm._v("Institue of Molecular Biology Mainz"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    "padding-top": "12px",
                    "padding-bottom": "40px",
                  },
                },
                [
                  _c(
                    "a",
                    {
                      staticStyle: { margin: "12px" },
                      attrs: {
                        rel: "external noopener",
                        target: "_blank",
                        href: "https://en.snu.ac.kr/",
                        height: "128",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "logos",
                        attrs: {
                          src: require("./assets/snu_logo_opt.svg"),
                          height: "64",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticStyle: { margin: "12px" },
                      attrs: {
                        rel: "external noopener",
                        target: "_blank",
                        href: "https://www.imb.de/",
                        height: "128",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "logos",
                        attrs: {
                          src: require("./assets/imb_logo.png"),
                          height: "64",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }